import { apiGet } from '../api.ts'
import { useQuery } from '@tanstack/react-query'
import { QueryCacheKeys } from '@/api/queryKeys.ts'
import { createUrl } from '@/util/url.ts'
import { MINUTE } from '@/constant/time.ts'
import { WanderingStatus, determineWanderingStatus } from '@/util/location.ts'
import { AlertStatus, DeviceStatus } from './getUsers.ts'

export interface IUserAll {
    id: number
    name: string
    location?: IPosition
    todayAlert: AlertStatus
    deviceStatus: DeviceStatus
    wanderingStatus: WanderingStatus
    distanceFromHome?: number
    addressLatitude?: number
    addressLongitude?: number
}

export interface IPosition {
    latitude: number
    longitude: number
    timestamp: string
    accuracy: number
}

export const apiGetUsersAll = async () => {
    const response = await apiGet<any[]>(createUrl(`/protectee`))
    
    // 배회 상태 계산을 모든 사용자에 대해 수행
    const users: IUserAll[] = response.data.map((user: any) => {
        let wanderingStatus = WanderingStatus.UNKNOWN
        let distanceFromHome: number | undefined = undefined
        
        if (user.addressLatitude && user.addressLongitude && 
            user.location?.latitude && user.location?.longitude) {
            const result = determineWanderingStatus(
                user.location.latitude,
                user.location.longitude,
                user.addressLatitude,
                user.addressLongitude
            )
            wanderingStatus = result.status
            distanceFromHome = result.distance
        }
        
        return {
            id: user.id,
            name: user.name,
            location: user.location,
            todayAlert: user.alertStatus || AlertStatus.NONE,
            deviceStatus: user.device?.status || DeviceStatus.OFFLINE,
            wanderingStatus,
            distanceFromHome,
            addressLatitude: user.addressLatitude,
            addressLongitude: user.addressLongitude
        }
    })
    
    return { ...response, data: users }
}

const useQueryGetUsersAll = () => {
    return useQuery({
        queryKey: QueryCacheKeys.user.getUsers(),
        // 배회감지 중심이므로 5분마다 갱신 (생체신호보다 덜 급함)
        refetchInterval: 5 * MINUTE,
        queryFn: async () => {
            const { data } = await apiGetUsersAll()
            return data
        }
    })
}

export default useQueryGetUsersAll
